export default __webpack_public_path__ + "static/media/d_wdt_c_1.d07388c9.mp3";